module.exports = __webpack_public_path__ + "static/img/product6.bca1969.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/black/product6.png
// module id = FFs+
// module chunks = 0